var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractComponent } from 'gp-admin-abstract';
var RadioButtonComponent = /** @class */ (function (_super) {
    __extends(RadioButtonComponent, _super);
    function RadioButtonComponent(el, changeDetector) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        _this.changeDetector = changeDetector;
        /**
         * Текст ошибки
         *
         * @type {string | boolean}
         */
        _this.error = false;
        /**
         * Дисаблед
         *
         * @type {boolean}
         */
        _this.disabled = false;
        _this.options = [];
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    RadioButtonComponent.prototype.ngAfterViewChecked = function () {
        var opts = this.getElementRef().nativeElement.querySelectorAll('option');
        if (opts.length > 0) {
            var needChanges = false;
            var _loop_1 = function (option) {
                var exists = this_1.options.find(function (f) { return f.value === option.value; });
                if (!exists) {
                    this_1.options.push({ value: option.value, text: option.text, selected: this_1.value === option.value });
                    if (option.selected) {
                        this_1.propagateChange(option.value);
                    }
                    needChanges = true;
                }
            };
            var this_1 = this;
            for (var _i = 0, opts_1 = opts; _i < opts_1.length; _i++) {
                var option = opts_1[_i];
                _loop_1(option);
            }
            if (needChanges) {
                this.changeDetector.detectChanges();
            }
        }
    };
    RadioButtonComponent.prototype.writeValue = function (obj) {
        var _this = this;
        this.options.forEach(function (item, index) {
            _this.options[index].selected = obj === item.value;
        });
    };
    RadioButtonComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    RadioButtonComponent.prototype.registerOnTouched = function (fn) {
    };
    RadioButtonComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    RadioButtonComponent.prototype.onChange = function (e, event) {
        var _this = this;
        if (!event.currentTarget.checked) {
            event.currentTarget.checked = true;
        }
        else {
            this.options.forEach(function (item, index) {
                _this.options[index].selected = e === item.value;
            });
        }
        this.propagateChange(e);
    };
    RadioButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-radio-button',
                    template: "\n<div style=\"display: none\">\n  <ng-content select=\"option\"></ng-content>\n</div>\n\n<label class=\"gp-radio-button flex flex--align-center cursor-pointer {{extraClass}}\"\n       *ngFor=\"let option of options\">\n\n  <input\n    type=\"checkbox\"\n    class=\"gp-radio-button__input\"\n    [ngClass]=\"{\n      'gp-radio-button__input--error': !!error,\n      'gp-radio-button__input--disabled': disabled\n    }\"\n    hidden\n    [name]=\"name\"\n    [disabled]=\"disabled\"\n    [ngModel]=\"option.selected\"\n    (click)=\"onChange(option.value, $event)\"\n  >\n\n  <span class=\"gp-radio-button__radio margin--right-1\"></span>\n\n  <span class=\"gp-radio-button__description\">{{ option.text }}</span>\n\n</label>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-radio-button\"\n */\n.gp-radio-button__radio {\n  position: relative;\n  display: block;\n  width: 2rem;\n  height: 2rem;\n  -moz-transition: all 300ms ease;\n  -o-transition: all 300ms ease;\n  -webkit-transition: all 300ms ease;\n  transition: all 300ms ease;\n  border: 0.1rem solid #d3d3d3;\n  border-radius: 50%;\n  background-color: var(--color-white); }\n\n.gp-radio-button__input:checked + .gp-radio-button__radio {\n  border-color: #00afec;\n  background-color: #00afec; }\n\n.gp-radio-button__input:checked + span + .gp-radio-button__description {\n  color: #212121; }\n\n.gp-radio-button__input--error + .gp-radio-button__radio {\n  border-color: #f35252;\n  background-color: var(--color-white); }\n\n.gp-radio-button__input--error + span + .gp-radio-button__description {\n  color: #f35252; }\n\n.gp-radio-button__input--disabled + .gp-radio-button__radio {\n  cursor: not-allowed;\n  border-color: #b5b5b5; }\n\n.gp-radio-button__input--disabled + .gp-radio-button__radio:before {\n  background-color: #b5b5b5; }\n\n.gp-radio-button__input--disabled + span + .gp-radio-button__description {\n  cursor: not-allowed;\n  color: #b5b5b5; }\n\n.gp-radio-button__radio:before {\n  position: absolute;\n  width: 0.6rem;\n  height: 0.6rem;\n  margin: 0.6rem;\n  content: '';\n  -moz-transition: background-color 300ms ease;\n  -o-transition: background-color 300ms ease;\n  -webkit-transition: background-color 300ms ease;\n  transition: background-color 300ms ease;\n  border-radius: 50%;\n  background-color: var(--color-white); }\n\n.gp-radio-button__description {\n  font: 1.4rem/1.6rem \"Roboto\", sans-serif;\n  -moz-transition: color 300ms ease;\n  -o-transition: color 300ms ease;\n  -webkit-transition: color 300ms ease;\n  transition: color 300ms ease;\n  color: #212121; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: RadioButtonComponent,
                            multi: true
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    RadioButtonComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: ChangeDetectorRef, },
    ]; };
    RadioButtonComponent.propDecorators = {
        'name': [{ type: Input },],
        'error': [{ type: Input },],
        'disabled': [{ type: Input },],
        'value': [{ type: Input },],
    };
    return RadioButtonComponent;
}(AbstractComponent));
export { RadioButtonComponent };
//# sourceMappingURL=radio-button.component.js.map